import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Line } from "react-chartjs-2";
import NavigationMenu from "../NavigationMenu";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

import { GetTotalScoreHistory } from "../services/Service";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

function TotalScoreGraph() {
  const [chartData, setChartData] = useState(null);
  const [maxScore, setMaxScore] = useState(100);

  useEffect(() => {
    GetTotalScoreHistory()
      .then((res) => {
        const rows = res?.data?.data || res?.data || [];

        if (!Array.isArray(rows) || rows.length === 0) return;

        const cleaned = rows
          .map((r) => ({
            date: new Date(r.date),
            score: Number(r.score),
          }))
          .filter(
            (r) =>
              !isNaN(r.date.getTime()) &&
              Number.isFinite(r.score)
          );

        if (cleaned.length === 0) return;

        const labels = cleaned.map((r) =>
          r.date.toLocaleDateString("en-GB")
        );

        const scores = cleaned.map((r) => r.score);

        const max = Math.max(...scores);
        setMaxScore(max + 5);

        setChartData({
          labels,
          datasets: [
            {
              label: "Total Score",
              data: scores,
              borderColor: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.1)",
              borderWidth: 3,
              tension: 0.4,
              fill: true,

              pointBackgroundColor: "#ffffff",
              pointBorderColor: "#4e6f95",
              pointBorderWidth: 2,
              pointRadius: 5,
              pointHoverRadius: 7,
            },
          ],
        });
      })
      .catch((err) => {
        console.error("Error fetching score history:", err);
      });
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#000",
        titleColor: "#fff",
        bodyColor: "#fff",
      },
    },
    layout: {
      padding: 10,
    },
    scales: {
      y: {
  min: 0,
  max: 100,

  ticks: {
    color: "#ffffff",
    stepSize: 20, // 0,20,40,60,80,100
  },

  grid: {
    color: "rgba(255,255,255,0.15)",
  },

  border: {
    color: "#ffffff",
    width: 2,
  },
},
      x: {
        ticks: {
          color: "#ffffff",
          maxRotation: 90,
          minRotation: 90,
          font: {
            size: 12,
          },
        },
        grid: {
          drawOnChartArea: false,
        },
        border: {
          color: "#ffffff",
          width: 2,
        },
      },
    },
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#f5f7fb" }}>
      {/* Sidebar */}
      <NavigationMenu pageName={"Total Scores"} />

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 20px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "520px",
            background: "linear-gradient(135deg, #6f8fb8, #7d9cc1)",
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: "20px",
              fontWeight: 600,
              marginBottom: "16px",
              textAlign: "center",
              letterSpacing: "0.5px",
            }}
          >
            DECAMA TOTAL SCORES
          </Typography>

          <Box sx={{ height: "300px" }}>
            {chartData ? (
              <Line data={chartData} options={options} />
            ) : (
              <Typography
                sx={{
                  color: "#ffffff",
                  textAlign: "center",
                  marginTop: "40px",
                }}
              >
                None
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default TotalScoreGraph;